import { useReducer } from "react";
import { useToast } from "../useToast";
// import {fetch} from "./service";

const init = () => {
	return {
		isLoading: false,
		isError: false,
		data: null,
	};
};

const dataFetchReducer = (state, action) => {
	switch (action.type) {
		case "SET_LOADING":
			return {
				...state,
				isLoading: action.value,
			};
		case "FETCH_INIT":
			return {
				...state,
				isLoading: true,
				isError: false,
			};
		case "FETCH_SUCCESS":
			return {
				...state,
				isLoading: false,
				isError: false,
				data: action.payload,
			};
		case "FETCH_FAILURE":
			return {
				...state,
				isLoading: false,
				isError: true,
				data: action.payload,
			};
		case "RESET":
			return init();
		default:
			throw new Error();
	}
};

export const useFetchState = (options) => {
	const { showToast } = useToast();
	const [state, dispatch] = useReducer(
		(state, action) => {
			try {
				return dataFetchReducer(state, action);
			} catch (err) {
				console.log("Wrong Action type for useFetch reducer func!");
			}
		},
		{
			isLoading: false,
			isError: false,
			data: null,
		},
		init
	);

	const sendRequest = (request, body) => {
		if (!state.isLoading) {
			dispatch({ type: "FETCH_INIT" });
			request(body)
				.then((success) =>
					dispatch({ type: "FETCH_SUCCESS", payload: success })
				)
				.catch((error) => {
					// if (error.status !== 404) {
					showToast(error.data, "error");
					// }
					dispatch({ type: "FETCH_FAILURE", payload: error });
				});
		}
		// fetch({...options, body})
		//     .then(result => dispatch({ type: 'FETCH_SUCCESS', payload: result.data }))
		//     .catch(error => dispatch({ type: 'FETCH_FAILURE', payload: error}))
	};

	const setLoading = (value) => {
		dispatch({ type: "SET_LOADING", value });
	};

	return [state, sendRequest, setLoading];
};
